<template>
  <div>
    <div class="row">
      <div class="col-md-3 col-sm-6 col-12">
        <div class="info-box bg-warning">
          <span class="info-box-icon"><i class="far fa-calendar-alt"></i></span>
          <!-- <div class="overlay dark" v-show="distinctContactPercentage >= 100">
            <i class="fas fa-3x fa-check-circle"></i>
          </div> -->
          <div class="info-box-content">
            <span class="info-box-text">Distinct contact</span>
            <div class="info-box-number">{{ Number(distinctContacts).toLocaleString() }} - <span class="float-right">{{ Number(26000).toLocaleString()}}</span></div>

            <div class="progress">
              <!-- 26,0000 -->
              <div
                class="progress-bar"
                v-bind:style="{ width: distinctContactPercentage + '%' }"
              ></div>
            </div>
            <span class="progress-description">
              {{ distinctContactPercentage }}% achieved
            </span>
            <!-- <div class="gf-indicators-stamped">GFKP-08</div> -->
          </div>
          <!-- /.info-box-content -->
        </div>
        <!-- /.info-box -->
      </div>
      <div class="col-md-3 col-sm-6 col-12">
        <div class="info-box bg-success">
          <span class="info-box-icon"><i class="far fa-handshake"></i></span>

          <!-- <div class="overlay dark" v-show="averageContactPercentage >= 130">
            <i class="fas fa-3x fa-check-circle"></i>
          </div> -->
          <div class="info-box-content">
            <span class="info-box-text">Average contact</span>
            <span class="info-box-number">{{ Number(averageContactPercentage1).toLocaleString() }} - <span class="float-right">{{ Number(46.43).toLocaleString()}}</span></span>

            <div class="progress">
              <div
                class="progress-bar"
                v-bind:style="{ width: averageContactPercentage + '%' }"
              ></div>
            </div>
            <span class="progress-description">
              {{ averageContactPercentage }}% achieved
            </span>
            <!-- <div class="gf-indicators-stamped">GFKP-08</div> -->
          </div>
          <!-- /.info-box-content -->
        </div>
        <!-- /.info-box -->
      </div>
      
      <div class="col-md-3 col-sm-6 col-12">
        <div class="info-box bg-cyan">
          <span class="info-box-icon"><i class="fas fa-syringe"></i></span>

          <div class="overlay dark" v-show="syringePerPersonPercentage >= 100">
            <i class="fas fa-3x fa-check-circle"></i>
          </div>
          <div class="info-box-content">
            <span class="info-box-text">Syringe per person (Anually)</span>
            <span class="info-box-number">{{ syringePerPerson }} - <span class="float-right">250</span></span>

            <div class="progress">
              <div
                class="progress-bar"
                v-bind:style="{ width: syringePerPersonPercentage + '%' }"
              ></div>
            </div>
            <span class="progress-description">
              {{ syringePerPersonPercentage }}% achieved
            </span>
            <!-- <div class="gf-indicators-stamped">GFKP-08</div> -->
          </div>
          <!-- /.info-box-content -->
        </div>
        <!-- /.info-box -->
      </div>
      <div class="col-md-3 col-sm-6 col-12">
        <div class="info-box bg-danger">
          <span class="info-box-icon"><i class="fas fa-exchange-alt"></i></span>

          <div class="overlay dark" v-show="exchangeRatePercentage >= 100">
            <i class="fas fa-3x fa-check-circle"></i>
          </div>
          <div class="info-box-content">
            <span class="info-box-text">Exchange rate</span>
            <span class="info-box-number">{{ exchangeRatePercentage }}% </span>

            <div class="progress">
              <div
                class="progress-bar"
                v-bind:style="{ width: exchangeRatePercentage + '%' }"
              ></div>
            </div>
            <span class="progress-description">
              {{ exchangeRatePercentage }}%
            </span>
            <!-- <div class="gf-indicators-stamped">GFKP-08</div> -->
          </div>
          <!-- /.info-box-content -->
        </div>
        <!-- /.info-box -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "nsep-indicators",
  data() {
    return {
      indicators: null,
      distinctContacts: null,
      averageContacts: null,
      exchangeRate: null,
      syringePerPerson: null,
      distinctContactPercentage: 0,
      averageContactPercentage: 0,
      averageContactPercentage1: 0,
      exchangeRatePercentage: 0,
      syringePerPersonPercentage: 0,
    };
  },
  methods: {
    async callNsepIndicators() {
      await axios
        .get("nsepIndicators")
        .then((response) => {
          if (response.status == 200) {
            this.indicators = response.data;
            this.distinctContacts = this.indicators.DistinctSEPContact;
            this.averageContacts = this.indicators.AVGContact;
            this.exchangeRate = this.indicators.ExchangeRate;
            this.syringePerPerson = this.indicators.SyringePerPerson;

            // percentage calculation
            this.distinctContactPercentage = parseFloat(
              (parseInt(this.distinctContacts) / 26000) * 100
            ).toFixed(0);
            // this.averageContactPercentage = parseFloat(
            //   (parseInt(this.averageContacts) / 8000) * 100
            // ).toFixed(0);
            this.exchangeRatePercentage = parseFloat(
              parseFloat(this.exchangeRate) * 100
            ).toFixed(0);
            this.averageContactPercentage1 = parseFloat(
              parseFloat(this.averageContacts) * 100
            ).toFixed(2);
            this.averageContactPercentage = parseFloat(
              parseFloat(this.averageContacts) * 100
            ).toFixed(0);
            // need to recheck
            this.averageContactPercentage = parseFloat((this.averageContactPercentage/46.43) * 100).toFixed(0);
            this.syringePerPersonPercentage = parseFloat(
              (parseInt(this.syringePerPerson) / 250) * 100
            ).toFixed(0);
          }
        })
        .catch((error) => {
          this.errored = true;
        })
        .finally(() => (this.loader = false));
    },
  },
  mounted() {
    this.callNsepIndicators();
  },
};
</script>

<style lang="scss" scoped></style>
